var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropdownSubItem',{attrs:{"label":"Marketplace","options":_vm.MARKETPLACE_FILTER_OPTIONS,"selected-options":_vm.selectedOptions},on:{"on-apply":_vm.onApply}})}
var staticRenderFns = []

export { render, staticRenderFns }